// Determine brand based on hostname or environment
const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';

// Brand detection: if hostname contains 'southvan' or 'svm', it's SVM; otherwise ISM
const isSVM = hostname.includes('southvan') || hostname.includes('svm') || (typeof process !== 'undefined' && process.env.BRAND === 'svm');

const brandConfig = {
  svm: {
    clinicName: 'South Vancouver Medical Clinic',
    websiteUrl: 'SouthVanMed.com',
    loginUrl: 'SouthVanMed.com/login',
    serviceEmail: 'info@southvanmed.com',
    doctorName: 'Dr. Budai',
    homepageUrl: 'SouthVanMed.com'
  },
  ism: {
    clinicName: 'Richmond Instore Medical Clinic',
    websiteUrl: 'InstoreMed.com',
    loginUrl: 'InstoreMed.com/login',
    serviceEmail: 'info@instoremed.com',
    doctorName: 'Dr. Balint',
    homepageUrl: 'InStoreMed.com'
  }
};

const currentBrand = isSVM ? brandConfig.svm : brandConfig.ism;

const config = {
  // ✅ Dynamic API endpoints using REACT_APP_* environment variables
  service: process.env.REACT_APP_API_URL || 'https://api.instoremed.com',
  book_appointment: process.env.REACT_APP_BOOKING_URL || 'https://appointment.instoremed.com',
  order_labtest: process.env.REACT_APP_LABTEST_URL || 'https://instore.asklabtest.com',
  askmedication: process.env.REACT_APP_ASKMED_URL || 'https://instore.askmedication.com',
  askmedApiHost: process.env.REACT_APP_ASKMED_API_URL || 'https://api.instore.askmedication.com',
  immigration_url: process.env.REACT_APP_IMMIGRATION_URL || 'https://southvanmed.com',

  // ✅ Dynamic branding using current brand configuration
  homepageUrl: currentBrand.homepageUrl,
  clinicName: currentBrand.clinicName,
  service_email: currentBrand.serviceEmail,

  // ✅ Static configuration (same for all clinics)
  captcha_key: '6LcXWiwrAAAAAGGtQ5v5-nmPH7ti0W_hiyZ6WfQv',
  hasFamilyDoc: '3003',
  noFamilyDoc: '3005',
  askmedSecret: 'cXpMnLhQ*7#qX1i',
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_live_zBwdNiTL0ugUnUJLoi4uQ7Ck00CCTvsCFG',

  // Brand-specific configuration
  branding: currentBrand
};
export default config;
